<template>
  <AppHome>
    <div slot="main">
      <section>
        <List>
          <ListItemWithIcon slot="list-item" icon-position="left">
            <img slot="list-item-icon" src="~assets/images/icons/ic-fdm-apple/ic-fdm-apple.png">
            <div slot="list-item-text">
              Votre activité a été bloquée par l'utilisateur de ce compte FidMarques.
              <br>
              <br>
              <ButtonV3
                :loading="loading"
                :disabled="loading"
                text="Cliquez ici"
                text-uppercase
                :color="paletteFidmarques.yellow"
                bg-color="white"
                :border-color="paletteFidmarques.yellow"
                @click="sendEmailToUnblockAccount"
              />
              pour recevoir un email afin d'en débloquer l'accès.
            </div>
          </ListItemWithIcon>
        </List>
      </section>
    </div>
  </AppHome>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppHome   from '~/components/layout/Home'
import List              from '~/components/elements/List'
import ListItemWithIcon  from '~/components/elements/ListItemWithIcon'
import ButtonV3          from '~/components/elements/ButtonV3'
import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'
export default {
  components: {
    AppHome,
    List,
    ListItemWithIcon,
    ButtonV3,
  },
  mixins: [MixinPaletteFidmarques],
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters('auth', ['partnerAccessToken']),
  },
  methods: {
    ...mapActions(['addToast', 'addToastGenericError']),

    async sendEmailToUnblockAccount () {
      if (this.loading) { return }
      this.loading = true

      try {
        await this.$axios.post(
          '/api/send_email_to_unblock_registration',
          { accessToken: this.partnerAccessToken },
        )
      } catch (error) {
        this.$airbrake.notifyInAsync(error, { locator: 'RegistrationBlocked' }, { store: this.$store })
        this.addToastGenericError()
        this.loading = false
        return
      }

      this.addToast({
        text: 'Vous allez recevoir un email pour débloquer votre compte.',
        type: 'success',
        dismissAfter: 4000,
      })
      this.loading = false
    },
  },
}
</script>
